<template>
  <v-container grid-list-md class="no-padding">
    <v-layout wrap>
      <v-flex xs12 md6>
        <v-card>
          <v-card-title><h2>Zaloga (ne dela)</h2></v-card-title>
          <v-card-text>
            <div v-for="item in stock" :key="item.id">
              <p>{{ item.time | moment('DD. MM ob HH:mm:ss') }}</p>
              <v-img :src="item.path" aspect-ratio="1.5" ></v-img>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6>
        <v-card>
          <v-card-title><h2>Nazadnje prisotni</h2></v-card-title>
          <v-card-text>
            <table>
              <tr v-for="(item, index) in sortedVisitors" :key="item.mac">
                <td>{{ index + 1 }}</td>
                <td>{{ item.username }}</td>
                <td>{{ item.date | moment('DD. MM ob HH:mm') }}</td>
              </tr>
            </table>
            <!-- <div v-for="item in filteredVisitors" :key="item.mac">
              <span>{{ item.username }} </span>
              <span>{{ item.date | moment('DD. MM ob HH:mm:ss') }}</span>
            </div> -->
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import axios from 'axios';
import Vue from 'vue';

Vue.use(require('vue-moment'));

export default {
  data() {
    return {
      stock: null,
      visitors: [
        {
          mac: '00:00:00:00:00:00',
          date: '0000-00-00 00:00:00',
          type: 'nothing',
          username: 'noone',
        },
      ],
    };
  },
  mounted() {
    axios
      .get('//plc.krdm.si/api.php', {
        params: {
          limit: '1',
          data: 'photo',
          source: 'fridge',
        },
      })
      .then((response) => {
        this.stock = response.data.data;
      });

    axios
      .get('//plc.krdm.si/api.php', {
        params: {
          data: 'online',
          minutes: '9999999999999',
        },
      })
      .then((response) => {
        this.visitors = response.data.data;
      });
  },
  computed: {
    filteredVisitors() {
      return this.visitors.filter(item => item.type === 'person');
    },
    sortedVisitors() {
      return this.filteredVisitors.slice(0).sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        let result;
        if (dateA > dateB) {
          result = -1;
        } else if (dateA < dateB) {
          result = 1;
        } else {
          result = 0;
        }
        return result;
      });
    },
  },
};
</script>

<style>
  .no-padding {
    padding: 0;
  }
  td {
    padding-right: 15px;
  }
</style>
